
import React from 'react'
import '../scss/RankingSelector.css'
import {Link} from 'react-router-dom'

const RankingSelector = (props) => {
  const ranking = props.ranking
  const rankings = props.rankings
  const competicion = props.competicion

  if (rankings && competicion) {
    return <div className={'ranking-selector'}>
      <ul className={'ranking-selector__ul'}>
        {rankings.map((r) => {
          let selected = ''
          if (parseInt(ranking.id, 10) === parseInt(r.id, 10)) {
            selected = 'ranking-selector__item--selected'
          }
          return <li key={r.id} className={'ranking-selector__item ' + selected}>
            <Link to={`/competicion/${competicion.id}/ranking/${r.id}`}>
              {r.nombre}
            </Link>
          </li>
        })}
      </ul>
      <div className={'control-selector__shadow-left'} />
      <div className={'control-selector__shadow-right'} />
    </div>
  } else {
    return null
  }
}

export default RankingSelector



// WEBPACK FOOTER //
// ./src/components/RankingSelector.js